// The ?period= / ?from= / ?to= in a Hub ▸ Marketing address — pure, no
// imports (the API's offline gate runs it). Anything unknown or malformed
// falls back to "this month", so a pasted or old link never breaks the page.

export type Preset = "this_month" | "last_month" | "quarter" | "ytd" | "custom";
export const PRESET_VALUES: readonly Preset[] = ["this_month", "last_month", "quarter", "ytd", "custom"];
export interface PeriodState { preset: Preset; from: string; to: string }

const DAY = /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
export const isDay = (s: string | null | undefined): s is string => !!s && DAY.test(s) && !Number.isNaN(Date.parse(`${s}T00:00:00Z`)) && new Date(`${s}T00:00:00Z`).toISOString().slice(0, 10) === s;

export function parsePeriodParams(get: (k: string) => string | null, today: string): PeriodState {
  const raw = get("period");
  const preset: Preset = raw && (PRESET_VALUES as readonly string[]).includes(raw) ? (raw as Preset) : "this_month";
  const from = get("from"); const to = get("to");
  if (preset === "custom") {
    if (isDay(from) && isDay(to) && from <= to) return { preset, from, to };
    return { preset: "this_month", from: `${today.slice(0, 7)}-01`, to: today };
  }
  return { preset, from: isDay(from) ? from : `${today.slice(0, 7)}-01`, to: isDay(to) ? to : today };
}
